import { CreateJob } from "~/types/jobs";
import Header from "./Header";
import TextareaInput from "~/shared/TextareaInput";
import { StringRecord } from "~/types/record";

type ObservationSectionProps = {
    fields: Partial<CreateJob>;
    errors: StringRecord;
    handleChange: (name: string, value: any) => void;
    handleBlur: (name: string, value: any) => void;
};

const ObservationSection = ({ fields, errors, handleBlur, handleChange }: ObservationSectionProps) => {
    return (
        <>
            <Header>Deseja deixar uma observação para esse job?</Header>

            <TextareaInput
                name="observation"
                value={fields.observation ?? ""}
                onChange={handleChange}
                rows={10}
                style={{ padding: "10px" }}
                error={errors.observation}
                onBlur={handleBlur}
            />
        </>
    );
};

export default ObservationSection;
